import { ToggleButton, Tooltip, makeStyles, mergeClasses } from '@fluentui/react-components';
import { ThumbDislikeFilled, ThumbDislikeRegular, ThumbLikeFilled, ThumbLikeRegular } from '@fluentui/react-icons';

import { EAiRunFeedbackSentiment } from '../types';

const useStyles = makeStyles({
  button: {
    minWidth: '28px',
    width: '28px',
    height: '28px',
  },
  // The filled icon alone marks the selected thumb.
  buttonSelected: {
    backgroundColor: 'transparent',
  },
});

const RATING_ICONS = {
  [EAiRunFeedbackSentiment.POSITIVE]: { selected: ThumbLikeFilled, unselected: ThumbLikeRegular },
  [EAiRunFeedbackSentiment.NEGATIVE]: { selected: ThumbDislikeFilled, unselected: ThumbDislikeRegular },
};

const RATING_TOOLTIPS = {
  [EAiRunFeedbackSentiment.POSITIVE]: 'Send positive feedback',
  [EAiRunFeedbackSentiment.NEGATIVE]: 'Send negative feedback',
};

type TProps = {
  sentiment: EAiRunFeedbackSentiment;
  isSelected: boolean;
  disabled: boolean;
  onClick: () => void;
};

const AiRunFeedbackRatingButton = ({ sentiment, isSelected, disabled, onClick }: TProps) => {
  const classes = useStyles();
  const Icon = RATING_ICONS[sentiment][isSelected ? 'selected' : 'unselected'];

  return (
    <Tooltip content={RATING_TOOLTIPS[sentiment]} relationship="label" positioning="below" withArrow>
      <ToggleButton
        appearance="subtle"
        size="small"
        checked={isSelected}
        icon={<Icon />}
        className={mergeClasses(classes.button, isSelected && classes.buttonSelected)}
        onClick={onClick}
        disabled={disabled}
      />
    </Tooltip>
  );
};

export default AiRunFeedbackRatingButton;
